
import { Mail } from "lucide-react";

export const NewsletterHeader = () => {
  return (
    <>
      <div className="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
        <Mail className="w-6 h-6 text-primary" />
      </div>
      <h2 className="text-3xl font-bold">Restez informé</h2>
      <p className="text-lg text-muted-foreground">
        Inscrivez-vous à notre newsletter pour recevoir les dernières actualités et conseils santé directement dans votre boîte mail
      </p>
    </>
  );
};
